$(document).ready(function () {
  $(".my-video-links").venobox();
});

jQuery(document).ready(function ($) {
  $(".newsletter-form__field-wrapper .field__input").attr(
    "placeholder",
    "Enter email address"
  );

  if ($(window).width() > 1023) {
    var body = $("body").outerWidth();
    var contain = $(".container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    $("section.content-step-sec").css("padding-left", total);
    $(".list-icons-section").css("padding-right", total);
    $(".timeline-cont-sec .col-left .inner-box").css("padding-left", total);
    $(".sec-form-style2").css("padding-left", total);
  }

  if ($(window).width() > 1023) {
    var body = $("body").outerWidth();
    var contain = $(".story_section .container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    if (total < 1) {
      total = 10;
    }
    $(".level_section .level_slider").css("margin-left", total);
    $(".faqs_section .faqs_wrap").css("margin-right", total);
  }

  let level_slider = $(".level_slider");

  level_slider.addClass("owl-carousel");
  level_slider.addClass("owl-theme");

  level_slider.owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    autoHeight: false,
    dots: false,
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    responsive: {
      0: {
        items: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        autoplayTimeout: 8000,
        dots: true,
      },
      767: {
        items: 2.3,
        dots: true,
      },
      1036: {
        items: 3.2,
        dots: true,
      },
      1200: {
        items: 2.4,
      },
      1401: {
        items: 3.4,
      },
    },
  });

  let ingredients_slider = $(".ingredients_slider");

  ingredients_slider.addClass("owl-carousel");
  ingredients_slider.addClass("owl-theme");

  ingredients_slider.owlCarousel({
    items: 5,
    loop: true,
    center: true,
    autoWidth: true,
    margin: 90,
    nav: false,
    dots: false,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 12000,
    autoplaySpeed: 12000,
    responsive: {
      0: {
        items: 1.2,
        margin: 30,
      },
      767: {
        items: 2.5,
      },
      1200: {
        items: 3,
      },
    },
  });

  // Activate the first accordion item by default
  const firstItem = $(".accordion_item").first();
  const firstContent = firstItem.find(".accordion_content .hide-visually");

  firstItem.addClass("active");
  firstContent.css({
    position: "absolute",
    visibility: "hidden",
    display: "block",
  });
  const firstHeight = firstContent.outerHeight() + 60;

  firstContent.css({
    display: "none",
    visibility: "",
    position: "",
    height: firstHeight, // Set height for the active item
  });

  firstItem.find(".accordion_content").css({
    height: firstHeight, // Set the height to the content's height
  });

  // Accordion click functionality
  $(".accordion_item").click(function () {
    let element = $(this).find(".accordion_content .hide-visually");
    let elemheight = 0;

    element.css({
      position: "absolute",
      visibility: "hidden",
      display: "block",
    });
    elemheight = element.outerHeight() + 60;
    element.css({
      display: "none",
      visibility: "",
      position: "",
    });

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find(".accordion_content").css({
        height: "0",
      });
    } else {
      $(".accordion_content").css({
        height: "0",
      });

      $(".accordion_item").removeClass("active");

      $(this).addClass("active");
      $(this).find(".accordion_content").css({
        height: elemheight,
      });
    }
  });

  $(".tabs_wrap .tabs_row").hide();
  $('.tabs_wrap .tabs_row[data-tab="tab1"]').fadeIn();
  $(".tabs_item:first").addClass("active");
  $('.tabs_wrap .tabs_row[data-tab="tab1"]').addClass("active");

  $(".tabs_item").click(function () {
    $(".tabs_item").removeClass("active");
    $(this).addClass("active");

    let selectedTab = $(this).data("item");
    $(".tabs_wrap .tabs_row").fadeOut(300);
    $(".tabs_wrap .tabs_row").removeClass("active");

    setTimeout(function () {
      $('.tabs_wrap .tabs_row[data-tab="' + selectedTab + '"]').fadeIn(300);
      $('.tabs_wrap .tabs_row[data-tab="' + selectedTab + '"]').addClass(
        "active"
      );
    }, 300);
  });
});

jQuery(document).ready(function ($) {
  $(".product__info-wrapper .shopify-payment-button__button").text("Order Now");
});

// counter number slider start
$(".desc-list-slider")
  .on("initialized.owl.carousel changed.owl.carousel", function (e) {
    if (!e.namespace) {
      return;
    }
    var carousel = e.relatedTarget;
    var currentSlide = carousel.relative(carousel.current()) + 1;
    var totalSlides = carousel.items().length;

    // Function to format the number with leading zero
    function formatNumber(num) {
      return num < 10 ? "0" + num : num;
    }

    $(".slider-counter .current").text(formatNumber(currentSlide));
    $(".slider-counter .total").text(formatNumber(totalSlides));
  })
  .owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: true,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 7000,
  });

// counter number slider script end

// Slider Regenere does

$(document).ready(function () {
  $(".regenere_section_inner_two").owlCarousel({
    loop: true,
    margin: 0,
    items: 8,
    nav: false,
    autoplay: true, // Enable auto scroll
    autoplayTimeout: 2000, // Delay between slides (in ms)
    autoplayHoverPause: true, // Pause on hover
    dots: false,
    responsive: {
      0: { items: 2 },
      450: { items: 3 },
      600: { items: 5 },
      1037: { items: 8 },
      3000: { items: 8 },
    },
  });
});

//slider end
// Slider What inside

$(document).ready(function () {
  $(".what-inside-two").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    stagePadding: 0,
    navText: [
      '<span class="custom-prev"><i class="fa-solid fa-arrow-left"></i></span>',
      '<span class="custom-next"><i class="fa-solid fa-arrow-right"></i></span>',
    ],
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  });
});

//slider end
// Timeline Scroll Section
//  --------------------------------------------------------------
//  $(document).ready(function() {
//     const $timeline = $('.timeline');
// const $timelineItems = $timeline.find('li');
// const $defaultLine = $('.default-line');
// const $drawLine = $('.draw-line');
// const itemHeight = 190; // The height of each li item in pixels

// // Function to set the height of the default line on page load
// function setDefaultLineHeight() {
//     let totalHeight = 0;
//     $timelineItems.each(function() {
//         totalHeight += $(this).outerHeight();
//     });
//     $defaultLine.css('height', totalHeight + 'px');
//     $drawLine.css('height', totalHeight + 'px');
// }

// // Function to check which item is in view and adjust draw line height
// function checkInView() {
//     let scrollTop = $timeline.scrollTop();

//     // Remove the 'in-view' class from all items
//     $timelineItems.removeClass('in-view');

//     let totalHeight = 0;

//     // Check scroll positions for specific elements
//     if (scrollTop >= 200 && scrollTop < 260) {
//         // Add 'in-view' to the second item (index 1)
//         $timelineItems.eq(1).addClass('in-view');
//         totalHeight = $timelineItems.eq(0).outerHeight() + $timelineItems.eq(1).outerHeight();
//     } else if (scrollTop >= 260 && scrollTop < 350) {
//         // Add 'in-view' to the third item (index 2)
//         $timelineItems.eq(2).addClass('in-view');
//         totalHeight = $timelineItems.eq(0).outerHeight() + $timelineItems.eq(1).outerHeight() + $timelineItems.eq(2).outerHeight();
//     } else if (scrollTop >= 350) {
//         // Add 'in-view' to the fourth item (index 3)
//         $timelineItems.eq(3).addClass('in-view');
//         totalHeight = $timelineItems.eq(0).outerHeight() + $timelineItems.eq(1).outerHeight() + $timelineItems.eq(2).outerHeight() + $timelineItems.eq(3).outerHeight();
//     } else if (scrollTop < 200) {
//         // Add 'in-view' to the first item (index 0)
//         $timelineItems.eq(0).addClass('in-view');
//         totalHeight = $timelineItems.eq(0).outerHeight();
//     }

//     // Adjust the draw line height based on the total height of items in view
//     $drawLine.css('height', totalHeight + 'px');
// }

// // Set the height of the default line on page load
// setDefaultLineHeight();

// // Enable 'in-view' for the first item by default
// $timelineItems.first().addClass('in-view');

// // Initial check for in-view items
// checkInView();

// // Trigger the function on scroll within the timeline
// $timeline.on('scroll', function() {
//     checkInView();
// });

// // Also check on window resize (optional)
// $(window).on('resize', function() {
//     checkInView();
// });

// });

$(document).ready(function () {
    const $timeline = $('.timeline');
    const $timelineList = $timeline.find('ul');
    const $timelineItems = $timeline.find('li');
    const $drawLine = $('.draw-line');
    let currentIndex = 0;
    let interval;
    let itemHeights = [];
    let accumulatedHeights = [0];
    let isHovered = false;

    // Calculate item heights and accumulated positions
    function calculateHeights() {
        itemHeights = [];
        accumulatedHeights = [0];

        $timelineItems.each(function () {
            const height = $(this).outerHeight();
            itemHeights.push(height);
            accumulatedHeights.push(accumulatedHeights[accumulatedHeights.length - 1] + height);
        });

        $drawLine.css('height', '0');
        $timelineList.css('transform', `translateY(-${accumulatedHeights[currentIndex]}px)`);
        $drawLine.css('height', accumulatedHeights[currentIndex + 1] + 'px');
    }

    // Update active item and animation
    function updateSlide() {
        $timelineItems.removeClass('in-view');
        currentIndex = (currentIndex + 1) % $timelineItems.length;
        $timelineItems.eq(currentIndex).addClass('in-view');
        $drawLine.css('height', accumulatedHeights[currentIndex + 1] + 'px');
        const scrollPosition = accumulatedHeights[currentIndex];
        $timelineList.css('transform', `translateY(-${scrollPosition}px)`);
    }

    // Start autoplay
    function startAutoplay() {
        interval = setInterval(() => {
            if (!isHovered) {
                updateSlide();
            }
        }, 3000);
    }

    // Initial setup
    calculateHeights();
    startAutoplay();

    $(window).on('resize', calculateHeights);

    // Disable scroll on hover
    $timeline.hover(
        () => {
            isHovered = true;
            clearInterval(interval);
            disableScroll();
        },
        () => {
            isHovered = false;
            startAutoplay();
            enableScroll();
        }
    );

    // Disable scroll on touch start inside timeline
    $timeline.on('touchstart', function () {
        disableScroll();
    });
    $timeline.on('touchend', function () {
        enableScroll();
    });

    // Scroll lock helper functions
    function disableScroll() {
        $('body').css('overflow', 'hidden');
        document.addEventListener('wheel', preventDefault, { passive: false });
        document.addEventListener('touchmove', preventDefault, { passive: false });
    }

    function enableScroll() {
        $('body').css('overflow', '');
        document.removeEventListener('wheel', preventDefault, { passive: false });
        document.removeEventListener('touchmove', preventDefault, { passive: false });
    }

    function preventDefault(e) {
        e.preventDefault();
    }
});




$(document).ready(function () {
  // Select all anchor links with a hash (#) in the href
  $('a[href^="#"]').on("click", function (e) {
    // Prevent the default action
    e.preventDefault();

    // Get the target element (anchor) from the href attribute
    var target = this.hash;

    // Set an offset for the sticky header height
    var offset = 89; // Adjust this value to match the height of your sticky header

    // Animate the scroll to the target element, accounting for the offset
    $("html, body").animate(
      {
        scrollTop: $(target).offset()?.top - offset,
      },
      500
    ); // 500ms for smooth scrolling
  });
});

// Add a click event listener to the button
$(".header__icon--cart").click(function () {
  // Toggle the class 'active' on the target element
  jQuery("html").addClass("drawer-active");
});
$(".drawer__close").click(function () {
  // Toggle the class 'active' on the target element
  jQuery("html").removeClass("drawer-active");
});

// Read More Button

// document.querySelectorAll(".box-one").forEach(container => {
//   const btn = container.querySelector(".read-more-btn");
//   const moreText = container.querySelector(".more-text");
//   const dots = container.querySelector(".dots");

//   btn.addEventListener("click", () => {
//     if (moreText.style.display === "none") {
//       moreText.style.display = "inline";
//       dots.style.display = "none";
//       btn.textContent = "Read less";
//     } else {
//       moreText.style.display = "none";
//       dots.style.display = "inline";
//       btn.textContent = "Read more";
//     }
//   });
// });

document.querySelectorAll(".box-one").forEach((container) => {
  const btn = container.querySelector(".read-more-btn");
  const moreText = container.querySelector(".more-text");
  const dots = container.querySelector(".dots");

  btn.addEventListener("click", () => {
    container.classList.toggle("expanded");
  });
});

const ctaButton = document.getElementById("cta-button");
const hero = document.getElementById("hero");
const enableSticky = document.getElementById("enable-sticky-cta");
const secondLastSection = document.querySelector(".peptide-sec");

function handleStickyCTA() {
  // Ensure all required elements exist before proceeding
  if (!ctaButton || !hero || !secondLastSection) return;

  if (enableSticky && window.innerWidth <= 767) {
    const heroBottom = hero.getBoundingClientRect().bottom;
    const sectionTop = secondLastSection.getBoundingClientRect().top;

    if (heroBottom <= 0) {
      ctaButton.classList.add("sticky");
    } else {
      ctaButton.classList.remove("sticky");
    }

    if (sectionTop <= window.innerHeight) {
      ctaButton.classList.add("hidden");
    } else {
      ctaButton.classList.remove("hidden");
    }
  } else {
    ctaButton.classList.remove("sticky");
    ctaButton.classList.remove("hidden");
  }
}

window.addEventListener("scroll", handleStickyCTA);
window.addEventListener("resize", handleStickyCTA);


//color active

document.addEventListener("DOMContentLoaded", function () {
  const circles = document.querySelectorAll(".regenere-circle");
  let activeCircle = localStorage.getItem("activeCircle") || "1"; // default is 1

  circles.forEach((circle) => {
    // Apply class if it matches stored one
    if (circle.dataset.id === activeCircle) {
      circle.classList.add("active");
    }

    // On hover, change active
    circle.addEventListener("mouseenter", () => {
      circles.forEach((c) => c.classList.remove("active"));
      circle.classList.add("active");
      localStorage.setItem("activeCircle", circle.dataset.id);
    });
  });
});
